/**
 * HTTP 请求封装
 * 创建不同 baseURL 的 axios 实例
 */
import axios from 'axios'
import { TIMEOUT } from './config'
import {
  requestInterceptor,
  requestErrorInterceptor,
  responseInterceptor,
  responseErrorInterceptor,
} from './interceptors'

// 创建 axios 实例工厂
export function createHttpInstance(baseURL) {
  const instance = axios.create({
    baseURL,
    timeout: TIMEOUT,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })

  // 添加拦截器
  instance.interceptors.request.use(requestInterceptor, requestErrorInterceptor)
  instance.interceptors.response.use(
    responseInterceptor,
    responseErrorInterceptor,
  )

  return instance
}

// 创建不带 baseURL 的实例（用于完整 URL）
export function createFullHttpInstance() {
  const instance = axios.create({
    timeout: TIMEOUT,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })

  instance.interceptors.request.use(requestInterceptor, requestErrorInterceptor)
  instance.interceptors.response.use(
    responseInterceptor,
    responseErrorInterceptor,
  )

  return instance
}
